import {has, parseInt} from 'lodash'
import {DEVICE_TYPE_OFFICE, view} from '../constants'
import { AudioOptions } from './AudioOptions'
import { CensorshipRuleSet } from './CensorshipRuleSet'
import { Upload } from 'components/upload/Upload'
import { Image } from 'components/image/Image'
import feathers from 'utility/client'

export const Options = props => {
  const {type, options, onChange, business} = props

  const onInputChange = (e, property, value) => {
    onChange({...options, [property]: value ? value : e.target.value})
  }

  const onNumberInputChange = (e, property) => {
    onChange({...options, [property]: parseInt(e.target.value)})
  }

  const onFileRemove = () => {
    const [user, fileName] = options.farSideImageLabel.split('/').slice(-2)
    feathers
      .service('media')
      .remove(user, {query: {key: `${user}/${fileName}`}})
      .then(console.log)
      .catch(console.error)

    onChange({...options, farSideImageLabel: undefined})
  }

  return (
    <>
      <h4>Options</h4>

      <AudioOptions
        showJoinLeaveAudioButton={options.showJoinLeaveAudioButton}
        speakerMode={options.speakerMode}
        microphoneMode={options.microphoneMode}
        showMicrophoneButton={options.showMicrophoneButton}
        showTimer={options.showTimer}
        timerLimit={options.timerLimit}
        onChange={updated => {
          onChange({
            ...options,
            ...updated
          })
        }}
      />

      <div className="row mb-4 view-btn-yn">
        <div className="col-sm-5">Show View Button</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.showViewButton}
            onChange={e => onNumberInputChange(e, 'showViewButton')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      {
        has(options, 'showViewButton') && !options?.showViewButton ? (
          <div className="row mb-4 view-btn-yn">
            <div className="col-sm-5">View</div>
            <div className="col-sm-7 d-flex justify-content-end">
              <select
                value={options?.view}
                onChange={e => onInputChange(e, 'view')}
                className="form-control"
              >
                <option value={view.standard}>Standard View</option>
                <option value={view.allEqual}>All-Equal View</option>
              </select>
            </div>
          </div>
        ) : null
      }

      <div className="row mb-4 knock-btn-yn">
        <div className="col-sm-5">Show Knock Button</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.showKnockButton}
            onChange={e => onNumberInputChange(e, 'showKnockButton')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      <div className="row mb-4 show-timer">
        <div className="col-sm-5">Show Groups Button</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.showGroupsButton}
            onChange={e => onNumberInputChange(e, 'showGroupsButton')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      <div className={business.options?.whiteboardAccess ? 'row mb-4 white-btn-yn' : 'row mb-4 white-btn-yn area-disabled'}>
        <div className="col-sm-5">Show Whiteboard Button</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            disabled={!business.options?.whiteboardAccess}
            value={options?.showWhiteboardButton}
            onChange={e => onNumberInputChange(e, 'showWhiteboardButton')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      <div className="row mb-4 white-btn-yn">
        <div className="col-sm-5">Force full screen</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.forceFullScreen}
            onChange={e => onNumberInputChange(e, 'forceFullScreen')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      {type !== DEVICE_TYPE_OFFICE && (
        <div className="row mb-4 white-btn-yn area-disabled">
          <div className="col-sm-5">Remove User interface elements</div>
          <div className="col-sm-7 d-flex justify-content-end">
            <select
              value={options?.removeUiElements}
              onChange={e => onNumberInputChange(e, 'removeUiElements')}
              className="form-control"
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
      )}

      <div className="row mb-4 white-btn-yn area-disabled">
        <div className="col-sm-5">Remove PIP Video feeds</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.removePipVideoFeeds}
            onChange={e => onNumberInputChange(e, 'removePipVideoFeeds')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      <div className="row mb-4 white-btn-yn area-disabled">
        <div className="col-sm-5">Remove self-view</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.removeSelfView}
            onChange={e => onNumberInputChange(e, 'removeSelfView')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      <div className="row mb-4 white-btn-yn area-disabled">
        <div className="col-sm-5">Allow pinning</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.allowPinning}
            onChange={e => onNumberInputChange(e, 'allowPinning')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      <div className="row mb-4 white-btn-yn">
        <div className="col-sm-5">Allow remote control of audio by other devices</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.allowRemoteAudioControl}
            onChange={e => onNumberInputChange(e, 'allowRemoteAudioControl')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      <div className="row mb-4 white-btn-yn area-disabled">
        <div className="col-sm-5">Maximum resolution</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.maximumResolution}
            onChange={e => onInputChange(e, 'maximumResolution')}
            className="form-control"
          >
            <option value="180p">180p</option>
            <option value="320p">320p</option>
            <option value="480p">480p</option>
            <option value="720p">720p</option>
            <option value="1080p">1080p</option>
            <option value="4k">4k</option>
          </select>
          {options?.maximumResolution === '4k' && (
            <div className="mt-1 text-muted">
              <i className="text-warning fa fa-exclamation-triangle"></i>
              4k resolution will need high bandwidth usage
            </div>
          )}
        </div>
      </div>

      <div className="row mb-4 white-btn-yn area-disabled">
        <div className="col-sm-5">Turn off display power during sleep mode (On supported devices)</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.powerSavingMode}
            onChange={e => onNumberInputChange(e, 'powerSavingMode')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      <div className="row mb-4 white-btn-yn area-disabled">
        <div className="col-sm-5">Synchronize join and leave audio with other devices in group</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.syncJoinLeaveAudioWithGroup}
            onChange={e => onNumberInputChange(e, 'syncJoinLeaveAudioWithGroup')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      {
        business.options?.videoResolutionsAccess ? (
          <div>
            <div className="row mb-4 ext-btn-yn">
              <div className="col-sm-5">Video Resolution Options</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <select
                  value={options?.videoResolutionOptions}
                  onChange={e => onNumberInputChange(e, 'videoResolutionOptions')}
                  className="form-control"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>

            <div className={ options?.videoResolutionOptions ? 'row mb-4 ext-btn-yn' : 'row mb-4 ext-btn-yn area-disabled'}>
              <div className="col-sm-5">Preferred Codec</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <select
                  value={options?.preferredCodec}
                  onChange={e => onInputChange(e, 'preferredCodec')}
                  className="form-control"
                >
                  <option value="av1">AV1</option>
                  <option value="av1-exclude-vp9">AV1 exclude VP9</option>
                  <option value="vp9">VP9</option>
                  <option value="vp8">VP8</option>
                  <option value="h264">H264</option>
                </select>
              </div>
            </div>

            <div className={ options?.videoResolutionOptions ? 'row mb-4 ext-btn-yn' : 'row mb-4 ext-btn-yn area-disabled'}>
              <div className="col-sm-5">Adaptive Mode</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <select
                  value={options?.adaptiveMode}
                  onChange={e => onNumberInputChange(e, 'adaptiveMode')}
                  className="form-control"
                >
                  <option value="1">On</option>
                  <option value="0">Off</option>
                </select>
              </div>
            </div>

            <div className={ options?.videoResolutionOptions ? 'row mb-4 ext-btn-yn' : 'row mb-4 ext-btn-yn area-disabled'}>
              <div className="col-sm-5">SVC/Simulcast</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <select
                  value={options?.svcSimulcast}
                  onChange={e => onInputChange(e, 'svcSimulcast')}
                  className="form-control"
                >
                  <option value="svc">SVC</option>
                  <option value="simulcast">Simulcast</option>
                </select>
              </div>
            </div>

            <div className={ options?.videoResolutionOptions ? 'row mb-4 ext-btn-yn' : 'row mb-4 ext-btn-yn area-disabled'}>
              <div className="col-sm-5">Maximum Resolution</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <select
                  value={options?.maxResolution}
                  onChange={e => onInputChange(e, 'maxResolution')}
                  className="form-control"
                >
                  <option value="180p">180p</option>
                  <option value="360p">360p</option>
                  <option value="720p">720p</option>
                  <option value="1080p">1080p</option>
                  <option value="1440p">1440p</option>
                  <option value="2160p">2160p</option>
                </select>
              </div>
            </div>

            <div className={ options?.videoResolutionOptions ? 'row mb-4 ext-btn-yn' : 'row mb-4 ext-btn-yn area-disabled'}>
              <div className="col-sm-5">Minimum Resolution</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <select
                  value={options?.minResolution}
                  onChange={e => onInputChange(e, 'minResolution')}
                  className="form-control"
                >
                  <option value="180p">180p</option>
                  <option value="360p">360p</option>
                  <option value="720p">720p</option>
                  <option value="1080p">1080p</option>
                  <option value="1440p">1440p</option>
                  <option value="2160p">2160p</option>
                </select>
              </div>
            </div>
          </div>
        ) : null

      }

      <hr />

      <div className={ business.options?.externalCallingAccess ? 'row mb-4 ext-btn-yn' : 'row mb-4 ext-btn-yn area-disabled'}>
        <div className="col-sm-5">External Calling</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.allowExternalCalling}
            onChange={e => onNumberInputChange(e, 'allowExternalCalling')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      {
        business.options?.externalCallingAccess && options.allowExternalCalling ? <>
          <div>
            <div className="row mb-4 ext-btn-yn area-disabled">
              <div className="col-sm-5">Microsoft Teams</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <select
                  value={options?.microsoftTeams}
                  onChange={e => onNumberInputChange(e, 'microsoftTeams')}
                  className="form-control"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>

            <div className="row mb-4 ext-btn-yn">
              <div className="col-sm-5">Zoom</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <select
                  value={options?.zoom}
                  onChange={e => onNumberInputChange(e, 'zoom')}
                  className="form-control"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>

            <div className="row mb-4 ext-btn-yn area-disabled">
              <div className="col-sm-5">Google Meet</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <select
                  value={options?.googleMeet}
                  onChange={e => onNumberInputChange(e, 'googleMeet')}
                  className="form-control"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>

            <div className="row mb-4 ext-btn-yn area-disabled">
              <div className="col-sm-5">Webex</div>
              <div className="col-sm-7 d-flex justify-content-end">
                <select
                  value={options?.webex}
                  onChange={e => onNumberInputChange(e, 'webex')}
                  className="form-control"
                >
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>
          </div>
          <hr />
        </> : null
      }

      <div className="row mb-4 ext-btn-yn">
        <div className="col-sm-5">Hide User Interface elements</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.hideUserInterfaceElements}
            onChange={e => {
              onNumberInputChange(e, 'hideUserInterfaceElements')
              onChange({
                ...options,
                ...{
                  hideUserInterfaceElements: parseInt(e.target.value),
                  hideSelfView: 0,
                  hideButtons: 0,
                  hideVideoTray: 0,
                  hideOtherText: 0,
                  hideLogos: 0,
                }
              })
            }}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>
      {options.hideUserInterfaceElements ? (
        <div>
          <div className="row mb-4 ext-btn-yn">
            <div className="col-sm-5">Hide self-view</div>
            <div className="col-sm-7 d-flex justify-content-end">
              <select
                value={options?.hideSelfView}
                onChange={e => onNumberInputChange(e, 'hideSelfView')}
                className="form-control"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="row mb-4 ext-btn-yn">
            <div className="col-sm-5">Hide buttons</div>
            <div className="col-sm-7 d-flex justify-content-end">
              <select
                value={options?.hideButtons}
                onChange={e => onNumberInputChange(e, 'hideButtons')}
                className="form-control"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="row mb-4 ext-btn-yn">
            <div className="col-sm-5">Hide video tray</div>
            <div className="col-sm-7 d-flex justify-content-end">
              <select
                value={options?.hideVideoTray}
                onChange={e => onNumberInputChange(e, 'hideVideoTray')}
                className="form-control"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="row mb-4 ext-btn-yn">
            <div className="col-sm-5">Hide other text</div>
            <div className="col-sm-7 d-flex justify-content-end">
              <select
                value={options?.hideOtherText}
                onChange={e => onNumberInputChange(e, 'hideOtherText')}
                className="form-control"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="row mb-4 ext-btn-yn">
            <div className="col-sm-5">Hide logos</div>
            <div className="col-sm-7 d-flex justify-content-end">
              <select
                value={options?.hideLogos}
                onChange={e => onNumberInputChange(e, 'hideLogos')}
                className="form-control"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-4 col-lg-5 col-form-label">Image Label (optional)</label>
            <div className="col-sm-8 col-lg-7">
              <Upload onChange={(data) => onChange({...options, farSideImageLabel: data.uri})} />
              <div className="text-center my-1">or</div>
              <input
                type="text"
                placeholder="Upload via URL"
                className="form-control"
                name="logo"
                value={options?.farSideImageLabel}
                onChange={e => onInputChange(e, 'farSideImageLabel')}
              />
              <small className="form-text text-muted">
                <i className="fas fa-info text-warning"></i> The image label be shown to far side when paired.
              </small>
              <Image src={options?.farSideImageLabel} width="100px" height="100px" onClick={onFileRemove} />
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-sm-5">Image Label Settings</div>
            <div className="col-sm-7 d-flex justify-content-between">
              <div className="row">
                <div className="col-md-3 col-sm-12">
                  Placement
                  <select
                    value={options?.imageLabelPlacement}
                    onChange={e => onInputChange(e, 'imageLabelPlacement')}
                    className="form-control"
                  >
                    <option value="top">Top</option>
                    <option value="bottom">Bottom</option>
                    <option value="left">Left</option>
                    <option value="right">Right</option>
                  </select>
                </div>

                <div className="col-md-3 col-sm-12">
                  Transparency
                  <input
                    min={0}
                    max={100}
                    pattern="[0-9]*"
                    type="number"
                    className="form-control"
                    placeholder="Percentage"
                    value={options?.imageLabelTransparency}
                    onChange={e => onNumberInputChange(e, 'imageLabelTransparency')}
                  />
                </div>

                <div className="col-md-3 col-sm-12">
                  Spacing
                  <input
                    pattern="[0-9]*"
                    type="number"
                    className="form-control"
                    placeholder="Percentage"
                    value={options?.imageLabelSpacing}
                    onChange={e => onNumberInputChange(e, 'imageLabelSpacing')}
                  />
                </div>

                <div className="col-md-3 col-sm-12">
                  Size
                  <input
                    pattern="[0-9]*"
                    type="number"
                    className="form-control"
                    placeholder="Percentage"
                    value={options?.imageLabelSize}
                    onChange={e => onNumberInputChange(e, 'imageLabelSize')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <div className="row mb-4 white-btn-yn">
        <div className="col-sm-5">Enable censorship</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={options?.enableCensorship}
            onChange={e => onNumberInputChange(e, 'enableCensorship')}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>
      {options.enableCensorship ?
        <div>
          <div className="row mb-4 show-timer-limit">
            <div className="col-sm-5">Length of blur(seconds)</div>
            <div className="col-sm-7 d-flex justify-content-end">
              <input
                pattern="[0-9]*"
                type="number"
                className="form-control"
                placeholder="Enter value in percentage"
                value={options?.censorshipPeriod}
                onChange={e => onNumberInputChange(e, 'censorshipPeriod')}
              />
            </div>
          </div>
          <div className="row mb-4 white-btn-yn">
            <div className="col-sm-5">Debug Mode</div>
            <div className="col-sm-7 d-flex justify-content-end">
              <select
                value={options?.censorshipDebugMode}
                onChange={e => onNumberInputChange(e, 'censorshipDebugMode')}
                className="form-control"
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="row mb-4 white-btn-yn">
            <div className="col-sm-5">Object obtrusion rules</div>
            <div className="col-sm-7">
              <CensorshipRuleSet
                rules={options?.censorshipRules}
                onChange={value => {
                  onChange({
                    ...options,
                    censorshipRules: value
                  })
                }}
              />
            </div>
          </div>
        </div>
      : null}
    </>
  )
}
